<template>
    <div :class="stateClasses" class="field">
        <label v-if="label" :for="name" class="field__label"> {{ label }} <span v-if="required">*</span> </label>
        <input
            v-bind="$attrs"
            :name="name"
            :id="name"
            :value="newValue"
            :type="type"
            :class="inputClass"
            ref="simpleTextInput"
            @input="onInput"
            @focus="onFocus"
            @blur="onBlur"
        />
        <template v-if="error">
            <span class="field__message">
                <small>{{ error }}</small>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'SimpleTextInput',
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        label: {
            type: String,
            default: null,
            required: false
        },
        name: {
            type: String,
            default: '',
            required: true
        },
        type: {
            type: String,
            default: 'text'
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        focus: {
            type: Boolean,
            default: false,
            required: false
        },
        error: {
            type: String,
            default: null
        },
        'input-class': {
            type: String,
            default: 'field__input dns-zones__input | u-margin-bottom-flush'
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            newValue: this.value
        };
    },
    computed: {
        /**
         * Generate the state classes.
         *
         * @return {object}
         */
        stateClasses() {
            return {
                'has-error': this.error
            };
        }
    },
    /**
     * Component is mounted, set the focus on the input if ref prop is true.
     */
    mounted() {
        this.autofocus();
    },
    watch: {
        /**
         * When v-model is changed:
         *   1. Set internal value.
         *   2. If it's invalid, validate again.
         *
         * @param {string} value
         */
        value(value) {
            this.newValue = value;
        },

        /**
         * Update the v-model and validate again whenever
         * internal value is changed.
         *
         * @param {string} value
         */
        newValue(value) {
            this.$emit('input', value);
        }
    },
    methods: {
        /**
         * Input's 'input' event listener, 'nextTick' is used to prevent event firing
         * before ui update, helps when using masks (Cleavejs and potentially others).
         *
         * @param {object} event
         */
        onInput(event) {
            this.$nextTick(() => {
                this.newValue = event.target.value;
            });
        },

        /**
         * Return a focus event to the parent component if you focus on the input.
         */
        onFocus() {
            this.$emit('focus');
        },

        /**
         * Return a blur event to the parent component if you blur the input.
         */
        onBlur() {
            this.$emit('blur');
        },

        /**
         * Put focus on the text input.
         */
        autofocus() {
            if (!this.focus) {
                return;
            }

            this.$refs.simpleTextInput.focus();
        }
    }
};
</script>
